{
  "receive.heading": "Receive",
  "receive.description": "This page shows the status, cycle, and number of containers and packages in the receive process",
  "receive.filter.title": "Options",
  "receive.filter.cycle": "Cycle",
  "status.current_planned": "Current Planned",
  "status.planned_inducted": "Current Inducted Actual",
  "status.unplanned_inducted": "Other/Unplanned Inducted Actual",
  "CPT.": "CPT",
  "CPT.cpt": "CPT",
  "CPT.induct_by": "Induct By",
  "CPT.stow_by": "Stow BY",
  "receive.overall_status": "Overall Status",
  "receive.packages": "Packages",
  "receive.predicted_dispatch": "Predicted Dispatch (LMCP)",
  "receive.total_manifested": "Total manifested",
  "receive.container_planned_volume": "Container planned volume",
  "receive.current_cycle_planned": "Current Cycle Planned",
  "receive.current_cycle_actual": "Current Cycle Arrived Actual",
  "receive.other_cycles": "Other/Unplanned Cycle Arrived Actual",
  "receive.current_planned": "Current Planned",
  "receive.current_actual": "Current Arrived Actual",
  "receive.other": "Other/Unplanned Arrived Actual",
  "receive.total": "Total Arrived Actual",
  "status.planned_inducted_cycle": "Current Cycle Inducted Actual",
  "status.unplanned_inducted_cycle": "Other/Unplanned Cycle Inducted Actual",
  "status.current_cycle_planned": "Current Cycle Planned",
  "status.total_inducted": "Total Inducted Actual",
  "receive.current_status": "Current status",
  "receive.manifested": "Manifested",
  "receive.manifested.unplanned": "Unplanned Manifested",
  "receive.in_transit": "In Transit",
  "receive.in_transit.unplanned": "Unplanned In Transit",
  "receive.arrived": "Arrived",
  "receive.arrived.unplanned": "Unplanned Arrived",
  "receive.marked_for_reprocess": "Marked for Reprocess",
  "receive.marked_for_reprocess.unplanned": "Unplanned Marked for Reprocess",
  "receive.inducted": "Inducted",
  "receive.stow_buffered": "Stow Buffered",
  "receive.stowed": "Stowed",
  "receive.sidelined": "Sidelined",
  "receive.group_by": "Group by",
  "linehaul.linehauls" : "Linehauls",
  "linehaul.status": "Status",
  "linehaul.arrival": "Arrival",
  "linehaul.details": "Details",
  "linehaul.vrid": "VRID",
  "linehaul.origin": "Origin",
  "linehaul.location": "Location",
  "linehaul.planned": "Planned",
  "linehaul.actual": "Actual",
  "linehaul.volume": "Volume",
  "linehaul.FMC": "FMC",
  "linehaul.unloadSequence": "Unload Sequence",
  "linehaul.inyard": "In Yard",
  "linehaul.arrived": "Arrived",
  "linehaul.incoming": "Incoming",
  "linehaul_detail.receive": "Receive",
  "linehaul_detail.linehaul_details": "Linehaul Details",
  "linehaul_detail.linehaul": "Linehaul ",
  "linehaul_detail.from": "From",
  "linehaul_detail.departed": "Departed",
  "linehaul_detail.arrived": "Arrived",
  "linehaul_detail.options": "Options",
  "linehaul_detail.id": "ID",
  "linehaul_detail.type": "Type",
  "linehaul_detail.pending_induct": "Pending Induct ",
  "linehaul_detail.total": "Total ",
  "linehaul_filter.packagesize": "Package Size",
  "linehaul_filter.ead": "Station EAD",
  "linehaul_filter.cycle": "Cycle",
  "linehaul_filter.cluster": "Cluster",
  "linehaul_filter.unplanned": "Unplanned",
  "linehaul_filter.sideline": "Sideline",
  "linehaul_filter.commercial": "Commercial",
  "linehaul_filter.cosmos": "Cosmos",
  "linehaul_filter.clear_all": "Clear all",
  "receivergroup.none": "None",
  "receivergroup.package_size": "Package Size",
  "receivergroup.station_ead": "Station EAD",
  "receivergroup.cluster": "Cluster",
  "receivergroup.cycle": "Cycle",
  "linehaul_filter.otherattributes": "Other Attributes",
  "induct.heading": "Induct",
  "induct.description": "This page shows the status, cycle, and number of containers and packages in the induct process",
  "induct.induct": "Induct",
  "induct.induct_area": "Induct Areas",
  "induct.induct_type": "Induct Type",
  "induct.manual": "Manual",
  "induct.automated": "Automated",
  "induct.active_associate": "Active associates",
  "induct.induct_rate": "Induct rate",
  "induct.total_inducted": "Total Inducted",
  "induct.container": "Container",
  "induct.container_id": "ID",
  "induct.type": "Type",
  "induct.pending_induct": "Pending Induct ",
  "induct.total": " Total",
  "induct.aslInductArea": "ASL Induct Area",
  "induct.max_induct_rate": "Max Induct rate",
  "induct.station_percentage": "% of station",
  "induct.successful_percentage": "% Successful",
  "induct.kickout": "Kickout",
  "induct.noread": "NoRead",
  "induct.timeout": "Timeout",
  "induct.failed_verification": "Failed Verification",
  "induct.sidelined": "Sidelined",
  "induct.cycle": "Cycle",
  "induct.unplanned": "Unplanned",
  "associate.heading": "Induct associates",
  "associate.description": "This page shows induct associates’ performance data and current working location",
  "associate.yes": "Yes",
  "associate.no": "No",
  "associate.option": "Options",
  "associate.active": "Active",
  "associate.associates": "Associates",
  "associate.associate": "Associate",
  "associate.pph": "PPH",
  "associate.hours": "Hours",
  "associate.total_packages": "Total Packages",
  "associate.location": "Location",
  "associate.inactive_period": "Inactive Period",
  "package.package_summary": "Package Summary",
  "package.tracking_id": "Tracking ID",
  "package.last_scan_date_time": "Last Scan",
  "package.minutes_in_state": "Minutes in State",
  "package.package_state": "State",
  "package.package_reason": "Reason",
  "package.location": "Location",
  "package.cycle": "Cycle",
  "package.cpt": "CPT",
  "package.sort_zone": "Sort Zone",
  "package.cluster": "Cluster",
  "package.EAD": "Station EAD",
  "package.size": "Size",
  "package.station_code": "Destination",
  "package.package_list": "Package List",
  "package.download": "Download",
  "induct.error": "Some Error Occured",
  "tooltip.predicated_lmcp": "LMCP forecast volume",
  "tooltip.current_planned": "Sort planner (RTW) Manifested shipments",
  "tooltip.planned_inducted": "Planned shipments which have been arrived OR inducted OR pending re-induct",
  "tooltip.unplanned_inducted": "Other shipments which have arrived the station",
  "tooltip.manifested": "Shipments planned for this time which have been manifested to a truck that is planned for the delivery station",
  "tooltip.unplanned_manifested": "Shipments NOT planned for this time which have been manifested to a truck that is planned for the delivery station",
  "tooltip.in_transit": "Shipments planned for this time which are in a truck in-transit to the delivery station",
  "tooltip.unplanned_in_transit": "Shipments NOT planned for this time which are in a truck in-transit to the delivery station",
  "tooltip.arrived": "Shipments planned for this time which have arrived the Delivery station",
  "tooltip.unplanned_arrived": "Shipments NOT planned for this time which have arrived the Delivery station",
  "tooltip.marked_for_reprocess": "Shipments planned for this time which have been resolved via Fixit",
  "tooltip.unplanned_marked_for_reprocess": "Shipments NOT planned for this time which have been resolved via Fixit",
  "tooltip.inducted": "Shipments that are currently in this package state and have been successfully inducted during this time",
  "tooltip.stowed": "Shipments that are currently in this package state and have been successfully stowed during this time",
  "tooltip.sidelined": "Shipments that are currently in the package state Held (Sidelined) and have been sidelined on induct during this time",
  "tooltip.current_cycle_planned": "Sort planner (RTW) Manifested shipments",
  "tooltip.planned_cycle_inducted": "Planned shipments which have been arrived OR inducted OR pending re-induct",
  "tooltip.unplanned_cycle_inducted": "Other shipments which have arrived the station",
  "tooltip.total_inducted_cycle": "Current Cycle Arrived plus Other/Unplanned Cycle Arrived Actual",
  "tooltip.current_arrived": "Planned shipments which have been arrived OR inducted OR pending re-induct",
  "tooltip.other_unplanned_arrived_actual": "Other shipments which have arrived the station",
  "tooltip.current_cycle_arrived": "Planned shipments which have been arrived OR inducted OR pending re-induct",
  "tooltip.other_unplanned_cycle_arrived_actual": "Other shipments which have arrived the station",
  "tooltip.total_arrived_actual_cycle": "Current Cycle Arrived plus Other/Unplanned Cycle Arrived Actual",
  "tooltip.manifested_cycle": "Shipments planned for this cycle which have been manifested to a truck that is planned for the delivery station",
  "tooltip.unplanned_manifested_cycle": "Shipments NOT planned for this cycle which have been manifested to a truck that is planned for the delivery station",
  "tooltip.in_transit_cycle": "Shipments planned for this cycle which are in a truck in-transit to the delivery station",
  "tooltip.unplanned_in_transit_cycle": "Shipments NOT planned for this cycle which are in a truck in-transit to the delivery station",
  "tooltip.arrived_cycle": "Shipments planned for this cycle which have arrived the Delivery station",
  "tooltip.unplanned_arrived_cycle": "Shipments NOT planned for this cycle which have arrived the Delivery station",
  "tooltip.marked_for_reprocess_cycle": "Shipments planned for this cycle which have been resolved via Fixit",
  "tooltip.unplanned_marked_for_reprocess_cycle": "Shipments NOT planned for this cycle which have been resolved via Fixit",
  "tooltip.inducted_cycle": "Shipments that are currently in this package state and have been successfully inducted during this cycle",
  "tooltip.stowbuffered_cycle": "Shipments that are currently in this package state and have been successfully stow buffered during this cycle",
  "tooltip.stowed_cycle": "Shipments that are currently in this package state and have been successfully stowed during this cycle",
  "tooltip.sidelined_cycle": "Shipments that are currently in the package state Held (Sidelined) and have been sidelined on induct during this cycle",
  "tooltip.total_arrived_actual": "Current Arrived plus Other/Unplanned Arrived Actual",
  "tooltip.max_induct_rate": "Maximum expected induct rate for the ASL machine.",
  "tooltip.induct_rate": "Average number of packages inducted per hour.",
  "tooltip.total_inducted": "Total number of packages inducted in the current shift.",
  "tooltip.station_percentage": "Percentage of total station volume that was inducted using the ASL machine.",
  "tooltip.successful_percentage": "Percentage of packages that were successfully scanned by the ASL machine.",
  "tooltip.non_conveyable_description": "NC: Packages that exceed 42'' in a single dimension. \n FCLM might have different dimension criteria for NC",
  "tooltip.kickout": "Number of packages that were kicked-out during ASL induct.",
  "tooltip.noread": "Number of ASL processed packages where a valid barcode was not read by the entry camera.",
  "tooltip.timeout": "Number of ASL processed package scans which did not receive induct response within the SLA.",
  "tooltip.failed_verification": "Number of ASL processed packages which were not verified by the exit camera.",
  "generic.error": "Some Error Occured",
  "generic.close": "Close",
  "generic.enabled" : "Enabled",
  "generic.disabled" : "Disabled",

  "header.induct_management": "Induct Management",

  "induct_management.induct_setup": "Induct Setup",
  "induct_management.select_cycle": "Select Cycle",
  "induct_management.current_sort_cycle": "Current Sort Cycle",
  "induct_management.current_cycle_state": "Current Cycle State",
  "induct_management.current_force_induct_status": "Current Force Induct Status",
  "induct_management.enable_force_induct": "Enable Force Induct",
  "induct_management.sort_cycle": "Sort Cycle",
  "induct_management.force_induct_sort_cycle": "Force induct all received packages in current sort cycle",
  "induct_management.start_sort_cycle": "Start Induct",
  "induct_management.container_plan_failure" : "There is an error fetching Container Plan. Please try again Later",
  "induct_management.mapped_cycles_failure" : "There is an error fetching Active Cycles. Please try again Later",
  "induct_management.set_node_operational_failure" : "There is an error saving the Induct Cycle. Please Try again Later",
  "induct_management.get_node_operational_failure" : "There is an error getting the current Sort Cycle Information. Please Try again Later",
  "induct_management.non_mco_station" : "This page is not enabled yet for your station. If your station supports multi cycle operations, stay tuned for more updates :-)",
  "induct_management.bad_request" : "Please select correct cycle from the dropdown",
  "induct_management.set_node_induct_process_details_success" : "Induct Cycle has been started successfully",
  "induct_management.no_active_container_plans_available" : "There are no active container plans configured for this station, Please try again later",
  "induct_management.pick_started_for_the_current_cycle" : "Pick has been started for the current cycle, so induct is blocked on ",
  "induct_management.start_induct" : ". Please change to correct cycle and start the induct process.",
  "common.data_last_updated": "Data last updated",
  "inductmanagement.heading": "Induct cycle management",
  "inductmanagement.description": "This page allows you to change induct cycle settings",
  "inductmanagement.manage_cycle": "Manage cycles",
  "inductmanagement.force_induct": "Force induct",
  "inductmanagement.active_until": "Active Until",
  "inductmanagement.noCycles": "No cycles available",
  "inductmanagement.disableCycle": "Disable cycle",
  "inductmanagement.enableCycle": "Enable cycle",
  "inductmanagement.enterCycle": "Enter Cycle...",
  "inductmanagement.enterStationCode": "Enter Station Code...",
  "inductmanagement.noStations": "No stations available",
  "inductmanagement.selectStatus": "Select Status...",
  "inductmanagement.enableForceInduct": "Enable force induct",
  "inductmanagement.disableForceInduct": "Disable force induct",
  "inductmanagement.activateSortToRouteError": "Cannot activate another SORT_TO_ROUTE type cycle. {cycle} is already active.",
  "inductmanagement.activateCycleError": "Encountered an error while activating cycle: {cycle}",
  "inductmanagement.deactivateCycleError": "Encountered an error while deactivating cycle: {cycle}",
  "inductmanagement.unselectedWarning": "Please select a node and cycle before clicking activate",
  "inductmanagement.setForceError": "Encountered an error while updating force induct for cycle: {cycleName}",
  "inductmanagement.deliveryWindowConfiguration": "Delivery window configuration",
  "inductmanagement.inductconfiguration" : "Induct Configurations",
  "inductconfig.uploadCsv": "Upload Configuration CSV",
  "inductconfig.cancel": "Cancel",
  "inductconfig.save": "Save Configuration",
  "inductconfig.chooseFile": "Choose File",
  "inductconfig.noFile": "No file chosen",
  "inductconfig.executeUpload": "Execute Upload",
  "inductconfig.downloadCsv": "Download CSV",
  "inductconfig.downloadTemplate": "Download Template",
  "inductconfig.selectCycle": "Select a cycle...",
  "inductconfig.noCycles": "No cycles available",
  "inductconfig.clickToEdit": "Click to Edit",
  "inductconfig.editingMode": "Editing Mode",
  "inductconfig.dockDoorsFormatError": "Use door names (e.g. DD1), separated by commas",
  "inductconfig.holdLanes": "Hold Lanes",
  "inductconfig.inactiveLanes": "Inactive Lanes",
  "inductconfig.palletLanes": "Pallet Lanes",
  "inductconfig.priorityLaneCount": "Priority Lane Count",
  "inductconfig.priorityLaneCountHint": "Use priority lanes count (e.g. 25)",
  "inductconfig.laneFormatError": "Use single values (e.g. IB.A23) or ranges (e.g. IB.A1:IB.A10), separated by commas",
  "inductconfig.belts": "Induct Belts",
  "inductconfig.selectBelt": "Select a belt...",
  "inductconfig.active": "Active",
  "inductconfig.inactive": "Inactive",
  "inductconfig.discard": "Discard",
  "inductconfig.addBelt": "Add belt",
  "inductconfig.saveSuccess": "Configuration saved successfully",
  "inductconfig.noBeltsConfigured": "No induct belts configured. Please add at least one belt.",
  "inductconfig.holdLaneWarning": "No hold lanes configured. Containers cannot be held during this cycle. Do you want to proceed?",
  "inductconfig.singleBeltWarning": "Only one active belt configured. If this belt goes down, no packages can be inducted. Do you want to proceed?",
  "inductconfig.inactiveHoldOverlap": "Inactive lane(s) {lanes} cannot also be in Hold lanes.",
  "inductconfig.inactivePalletOverlap": "Inactive lane(s) {lanes} cannot also be in Pallet lanes.",
  "inductconfig.saveError": "Failed to save configuration",
  "inductconfig.noActiveLanes": "All lanes are either inactive or hold lanes, no lanes left for pallet or cart.",
  "inductconfig.noCartLanes": "All lanes are either inactive, hold or pallet lanes. No lanes left for Carts.",
  "inductconfig.beltNoContainerTypes": "One or more belts have no container types selected. Select at least one container type for each belt.",
  "inductconfig.beltNoCubeTypes": "One or more belts have no cube types selected. Select at least one cube type for each belt.",
  "inductconfig.noActiveBelts": "No active induct belts configured. At least one belt must be active to process packages.",
  "inductconfig.containerTypeNotCovered": "One or more container types are not assigned to any active belt. All container types must be covered by at least one active belt.",
  "inductconfig.cubeTypeNotCovered": "One or more cube types are not assigned to any active belt. All cube types must be covered by at least one active belt.",
  "inductconfig.invalidLaneEntered": "Invalid lane entered. Please enter a valid lane identifier.",
  "inductconfig.uploadSuccess": "CSV uploaded successfully! Configuration fields have been updated.",
  "inductconfig.selectCycleBeforeUpload": "Please select a cycle before executing upload.",
  "inductconfig.invalidCycleInCsv": "Invalid or missing cycle in CSV. Please enter a valid cycle.",
  "inductconfig.uploadError": "Failed to upload configuration.",
  "inductconfig.duplicateLaneError": "Validation failed: Lane(s) cannot be in both Priority and Hold lanes.",
  "inductconfig.validationError": "Validation failed: Station code in CSV does not match the selected station.",
  "inductconfig.cycleMismatchError": "Validation failed: Cycle in CSV does not match the selected cycle.",
  "inductmanagement.dynamicCPlan": "Dynamic C.Plan",
  "tooltip.dynamicCPlan": "Container planning status for DRS cycles on Mobius workflow. Ready: The latest container plan is ready, induct can be started. Not Ready: The latest container plan is not ready, induct cannot be started. Failed Underplanned: Failed due to less sortzones configured.",
  "inductmanagement.getConfigFail": "Encountered an error while trying to retrieve package cycle configuration",
  "inductmanagement.setConfigFail": "Encountered an error while trying to set package cycle configuration",
  "inductmanagement.parallelNotEnabled": "Parallel induct tab has not been enabled for your station",
  "inductmanagement.notEnabled": "Scheduled delivery window configuration tab has not been enabled for your station",
  "inductmanagement.saveSuccess": "Configuration change sent successfully. Changes may take up to 60 minutes to be applicable for incoming scheduled delivery packages",
  "inductmanagement.noWindowsConfigured": "No scheduled delivery windows configured. Press edit to add new windows",
  "inductmanagement.start": "Start",
  "inductmanagement.end": "End",
  "inductmanagement.addNewWindow": "Add new window",
  "inductmanagement.deliveryWindow": "Delivery Window",
  "inductmanagement.cycles": "Cycles",
  "inductmanagement.save": "Save",
  "inductmanagement.edit": "Edit",
  "inductmanagement.submit": "Submit",
 "inbound.heading": "Inbound",
  "inbound.tabHeading": "Inbound",
  "inbound.description": "This page shows inbound operations and metrics",
  "inbound.overview": "Inbound Overview",
  "inbound.overview_description": "View inbound operations and metrics",
  "inbound.station_performance_summary": "Station Performance Summary",
  "inbound.total_fph": "Induct FPH",
  "inbound.packages_per_hour": "Packages Per Hour (All Lines)",
  "inbound.trend_vs_hourly_goal": "Trend vs. Hourly Goal (Selected Time Range)",
  "inbound.bottom_3_fph": "Bottom 3 FPH (By Impact)",
  "inbound.lost_hours": "Lost Hours",
  "inbound.cumulative_downtime": "Cumulative Downtime",
  "inbound.top_3_impacted_lines": "Top 3 Impacted Lines",
  "inbound.induct_dt_dpmo": "Induct Downtime DPMO",
  "inbound.defects_per_million": "Defects Per Million Opportunities",
  "inbound.top_3_volume_impact": "Top 3 by Volume Impact",
  "inbound.quality_metrics": "Quality Metrics",
  "inbound.top_impact_by_quality": "Top Impact by Quality Issue",
  "inbound.operating_lines": "Operating Lines",
  "inbound.pph_performance": "PPH Performance",
  "inbound.tooltip.total_fph": "Induct FPH: Packages inducted per hour across all lines at station level.",
  "inbound.tooltip.lost_hours": "Lost Hours: Downtime instances where the gap between consecutive packages on a single belt (TT) is 20–120 seconds.\n\n• TT > 20s & TT < 120s = Defect\n• Measured per belt, reported in hours\n• Cumulative across all active lines",
  "inbound.tooltip.induct_dt_dpmo": "Induct DT DPMO: Downtime defects per million induct opportunities.\n\nFormula:\n(Total downtime stops / Total inducted packages) × 1,000,000\n\nInclusions: Scan gaps 20–120 sec\nExclusions: Operators with <500 packages, induct code 'NC%'",
  "inbound.tooltip.quality_metrics": "Quality metrics tracking misapplied SAL, multi-read, and no-read rates across induct lines. Rates shown as percentage of total packages processed.",
  "inbound.filter.cycle": "Cycle",
  "inbound.filter.time_range": "Time Range",
  "inbound.filter.select_cycle": "Select Cycle",
  "inbound.filter.select_time_range": "Select Time Range",
  "inbound.filter.clear_all": "Clear all",
  "inbound.lost_hours_label": "Lost Hours",
  "inbound.actual_label": "Actual PPH",
  "inbound.benchmark_label": "Benchmark PPH",
  "inbound.loading_message": "Loading station performance data...",
  "inbound.error_loading_data": "Error loading data",
  "inbound.coming_soon": "Coming Soon",
  "inbound.fph_performance_detailed": "FPH Performance - Detailed View",
  "inbound.benchmark_aria_label": "100% benchmark",
  "inbound.active_induct_belts": "Active Induct Belts - PPH Performance",
  "inbound.performance_pct": "Performance",
  "inbound.close": "Close",
  "inbound.expand_belt_details": "Expand belt details",
  "inbound.unknown_belt": "Unknown",
  "inbound.view_policy": "View Policy",
  "inbound.inducted_packages_label": "Inducted Packages",
  "inbound.inducted_cube_label": "Inducted Cube",
  "inbound.total_packages": "Total Packages",
  "inbound.misapplied_sal": "Misapplied SAL",
  "inbound.multi_read": "Multi-read",
  "inbound.no_read": "No-read",
  "inbound.stow_metrics": "Stow Metrics",
  "inbound.stow_metrics_error": "Unable to load stow metrics",
  "stow.stow_fph": "Stow FPH",
  "stow.stow_wip_compliance": "Est. Stow WIP Compliance",
  "stow.stow_wip": "Stow WIP",
  "stow.target": "Target",
  "stow.target_min_max": "Target (min/max)",
  "stow.actual": "Actual",
  "tooltip.stow.stowFPH": "Stow Flow Per Hour: Calculated by stowed volume/ hour. Target: Total Volume left to be stowed/ Remaining Belt Run Time. Belt Run Time: SCMS Sort End Time - SCMS Sort Start Time - (Fast Start + Breaks + Lunch). Actual: Total Stowed Volume in the past running 10 min / hour",
  "tooltip.stow.stowWipCompliance": "Stow Work in Progress. Target: Goal determined by ACES. Actual: Qty. of intervals that have met WIP goal/ Total intervals that have passed during current cycle.",
  "tooltip.stow.stowWIP": "Target: Threshold defaulted to 15 min lower limit 30 min upper limit unless adjusted in the Settings page. Actual: (Inducted Pending Stow Volume / Stow FPH) * 60 min",
  "tooltip.stow.stowMetricsSection": "Stow metrics reflect real-time data for Cycle 1 only. Changing the Relative time period won't affect these values."
}
